import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./auth";
import microphoneReducer from "./microphone";
import tinyPlayerReducer from "./tinyPlayer";
import notificationReducer from "./notification";
import modalReducer from "./modal";
import modelReducer from "./model";
import folderReducer from "./folder";
import noteReducer from "./note";
import projectReducer from "./project";
import playerReducer from "./player";
import recordingReducer from "./recording";
import statsReducer from "./stats";
import stripeReducer from "./stripe";
import calibrationReducer from "./calibration";
import voiceReducer from "./voice";
import systemReducer from "./system";

const store =
  process.env.NODE_ENV === "test" || window.Cypress
    ? (preloadedState) =>
        configureStore({
          reducer: {
            auth: authReducer,
            microphone: microphoneReducer,
            tinyPlayer: tinyPlayerReducer,
            notification: notificationReducer,
            modal: modalReducer,
            model: modelReducer,
            folder: folderReducer,
            note: noteReducer,
            project: projectReducer,
            player: playerReducer,
            recording: recordingReducer,
            stats: statsReducer,
            stripe: stripeReducer,
            calibration: calibrationReducer,
            voice: voiceReducer,
            system: systemReducer,
          },
          /*
    TODO 
    https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
    "One of the core usage principles for Redux is that you should not put non-serializable values in state or actions."
    we're using Map type in recording state
  */

          middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
              serializableCheck: false,
            }),
          preloadedState,
        })
    : configureStore({
        reducer: {
          auth: authReducer,
          microphone: microphoneReducer,
          tinyPlayer: tinyPlayerReducer,
          notification: notificationReducer,
          modal: modalReducer,
          model: modelReducer,
          folder: folderReducer,
          note: noteReducer,
          project: projectReducer,
          player: playerReducer,
          recording: recordingReducer,
          stats: statsReducer,
          stripe: stripeReducer,
          calibration: calibrationReducer,
          voice: voiceReducer,
          system: systemReducer,
        },
        devTools: process.env.NODE_ENV === "development",
        /*
    TODO 
    https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
    "One of the core usage principles for Redux is that you should not put non-serializable values in state or actions."
    we're using Map type in recording state
  */

        middleware: (getDefaultMiddleware) =>
          getDefaultMiddleware({
            serializableCheck: false,
          }),
      });

export default store;
